export default {
  namespaced: true,
  state: {
    start: '2023/01/27 12:00', // 开始时间
    end: '2023/02/06', // 结束时间 零点
    popTime: 1, // 用户看到弹窗次数
    banner: 'https://cdnvue.gymcity.com.cn/uploads/23-coach-prove-banner',
    pop: 'https://cdnvue.gymcity.com.cn/uploads/23-coach-prove-pop', // 弹窗地址
    bg: 'https://cdnvue.gymcity.com.cn/uploads/23-coach-prove-bg', // 详情介绍背景图
    top: 'https://cdnvue.gymcity.com.cn/uploads/23-coach-prove-top' // 详情介绍背景图
  },
  getters: {},
  mutations: {},
  actions: {}
}
